import { gql } from '@apollo/client/core';

const financeApplication = {
  START: gql`
    mutation StartFinanceApplication($dealId: String!) {
      startFinanceApplication(dealId: $dealId) {
        code
      }
    }
  `,
};

export default financeApplication;
